import React, { useState } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { updateParametroCamion } from '../../actions'
import { obtenerEstimacionSemanal } from '../../actions/listados'
import CampoEditable from './CampoEditable'

function CamionPromedio (props) {
  const { peso, netoPromedio, change: formChange } = props
  const [neto, setNeto] = useState(peso)

  const handleInputBlur = async () => {
    if (netoPromedio && netoPromedio !== neto) {
      props.updateParametroCamion(netoPromedio)
      setNeto(netoPromedio)
      // formChange('netoPromedio', netoPromedio)
      props.obtenerEstimacionSemanal()
    }
  }

  const handleDisplayClick = () => {
    formChange('netoPromedio', neto)
  }

  return (
    <CampoEditable
      titulo='Peso camion promedio'
      name='netoPromedio'
      handleInputBlur={handleInputBlur}
      handleDisplayClick={handleDisplayClick}
      valor={neto}
    />
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state) => ({
  netoPromedio: selector(state, 'netoPromedio')
})

const mapActionsToProps = {
  updateParametroCamion,
  obtenerEstimacionSemanal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(CamionPromedio))
